module.exports = __webpack_public_path__ + "static/media/flexedigital.a605a64a.png";